import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
};

export type AccountBasedExpenseLineDetailModel = {
  __typename?: 'AccountBasedExpenseLineDetailModel';
  AccountRef: AccountRefClassModel;
  BillableStatus: Scalars['String'];
  CustomerRef?: Maybe<AccountRefClassModel>;
  TaxCodeRef: PaymentMethodRefClassModel;
};

export type AccountRefClassModel = {
  __typename?: 'AccountRefClassModel';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type AddressModel = {
  __typename?: 'AddressModel';
  City: Scalars['String'];
  Country?: Maybe<Scalars['String']>;
  CountrySubDivisionCode: Scalars['String'];
  Id: Scalars['String'];
  Lat: Scalars['String'];
  Line1: Scalars['String'];
  Long: Scalars['String'];
  PostalCode: Scalars['String'];
};

export type AnyModel = {
  __typename?: 'AnyModel';
  declaredType: Scalars['String'];
  globalScope: Scalars['Boolean'];
  name: Scalars['String'];
  nil: Scalars['Boolean'];
  scope: Scalars['String'];
  typeSubstituted: Scalars['Boolean'];
  value: Value;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']>;
  divide?: InputMaybe<Scalars['BigInt']>;
  increment?: InputMaybe<Scalars['BigInt']>;
  multiply?: InputMaybe<Scalars['BigInt']>;
  set?: InputMaybe<Scalars['BigInt']>;
};

export type CompanyInfoModel = {
  __typename?: 'CompanyInfoModel';
  CompanyName: Scalars['String'];
  CompanyStartDate: Scalars['DateTime'];
  Country: Scalars['String'];
  FiscalYearStartMonth: Scalars['String'];
  Id: Scalars['String'];
  LegalName: Scalars['String'];
  SupportedLanguages: Scalars['String'];
  SyncToken: Scalars['String'];
  domain: Scalars['String'];
  sparse: Scalars['Boolean'];
};

export type CurrencyRefModel = {
  __typename?: 'CurrencyRefModel';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CustomerModel = {
  __typename?: 'CustomerModel';
  Active: Scalars['Boolean'];
  Balance: Scalars['Float'];
  BalanceWithJobs: Scalars['Float'];
  BillAddr?: Maybe<AddressModel>;
  BillWithParent: Scalars['Boolean'];
  ClientEntityId: Scalars['String'];
  CompanyName?: Maybe<Scalars['String']>;
  CurrencyRef: CurrencyRefModel;
  DisplayName: Scalars['String'];
  FamilyName?: Maybe<Scalars['String']>;
  Fax?: Maybe<FaxModel>;
  FullyQualifiedName: Scalars['String'];
  GivenName?: Maybe<Scalars['String']>;
  Id: Scalars['String'];
  IsProject: Scalars['Boolean'];
  Job: Scalars['Boolean'];
  Level?: Maybe<Scalars['Float']>;
  MetaData: MetaDataModel;
  MiddleName?: Maybe<Scalars['String']>;
  Mobile?: Maybe<FaxModel>;
  ParentRef?: Maybe<ParentRefModel>;
  PreferredDeliveryMethod: Scalars['String'];
  PrimaryEmailAddr?: Maybe<PrimaryEmailAddrModel>;
  PrimaryPhone?: Maybe<PrimaryPhoneModel>;
  PrintOnCheckName: Scalars['String'];
  ShipAddr?: Maybe<AddressModel>;
  SyncToken: Scalars['String'];
  Taxable: Scalars['Boolean'];
  V4IDPseudonym: Scalars['String'];
  WebAddr?: Maybe<WebAddressModel>;
  domain: Scalars['String'];
  sparse: Scalars['Boolean'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type FaxModel = {
  __typename?: 'FaxModel';
  FreeFormNumber: Scalars['String'];
};

export type HourTimeSheetChargeCode = {
  __typename?: 'HourTimeSheetChargeCode';
  active: Scalars['Boolean'];
  billable: Scalars['Boolean'];
  chargeCodeName: Scalars['String'];
  children: Array<HourTimeSheetChargeCodeOrChild>;
  collectionName: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  hierarchicalName: Scalars['String'];
  id: Scalars['String'];
  leafName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['Float'];
  quickBooksId: Scalars['String'];
  required: Scalars['Boolean'];
};

export type HourTimeSheetChargeCodeOrChild = {
  __typename?: 'HourTimeSheetChargeCodeOrChild';
  active: Scalars['Boolean'];
  billable: Scalars['Boolean'];
  chargeCodeName: Scalars['String'];
  collectionName: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  hierarchicalName: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  quickBooksId: Scalars['String'];
  required: Scalars['Boolean'];
};

export type HourTimeSheetCostData = {
  __typename?: 'HourTimeSheetCostData';
  BillableCost: Scalars['Float'];
  Customer: Scalars['String'];
  DirectCost: Scalars['Float'];
  FirstName: Scalars['String'];
  Hours: Scalars['Float'];
  Job: Scalars['String'];
  LastName: Scalars['String'];
  ServiceItem: Scalars['String'];
  TimesheetEndingDate: Scalars['DateTime'];
};

export type HourTimesheet = {
  __typename?: 'HourTimesheet';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  subdomain: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type HourTimesheetAuthorized = {
  __typename?: 'HourTimesheetAuthorized';
  authorized: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type HourTimesheetCreateInput = {
  password: Scalars['String'];
  subdomain: Scalars['String'];
  username: Scalars['String'];
};

export type HourTimesheetCreateOrConnectWithoutUserInput = {
  create: HourTimesheetCreateWithoutUserInput;
  where: HourTimesheetWhereUniqueInput;
};

export type HourTimesheetCreateWithoutUserInput = {
  password: Scalars['String'];
  subdomain: Scalars['String'];
  username: Scalars['String'];
};

export type HourTimesheetData = {
  __typename?: 'HourTimesheetData';
  costData: Array<HourTimeSheetCostData>;
  customers: Array<HourTimeSheetChargeCode>;
  jobs: Array<HourTimeSheetChargeCode>;
  serviceItems: Array<HourTimeSheetChargeCode>;
};

export type HourTimesheetUpdateOneWithoutUserInput = {
  connect?: InputMaybe<HourTimesheetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<HourTimesheetCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<HourTimesheetCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<HourTimesheetUpdateWithoutUserInput>;
  upsert?: InputMaybe<HourTimesheetUpsertWithoutUserInput>;
};

export type HourTimesheetUpdateWithoutUserInput = {
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  subdomain?: InputMaybe<StringFieldUpdateOperationsInput>;
  username?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type HourTimesheetUpsertWithoutUserInput = {
  create: HourTimesheetCreateWithoutUserInput;
  update: HourTimesheetUpdateWithoutUserInput;
};

export type HourTimesheetWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type ItemBasedExpenseLineDetailModel = {
  __typename?: 'ItemBasedExpenseLineDetailModel';
  BillableStatus: Scalars['String'];
  ItemRef: AccountRefClassModel;
  Qty: Scalars['Float'];
  TaxCodeRef: PaymentMethodRefClassModel;
  UnitPrice: Scalars['Float'];
};

export type LineModel = {
  __typename?: 'LineModel';
  AccountBasedExpenseLineDetail?: Maybe<AccountBasedExpenseLineDetailModel>;
  Amount: Scalars['Float'];
  Description?: Maybe<Scalars['String']>;
  DetailType: Scalars['String'];
  Id: Scalars['String'];
  ItemBasedExpenseLineDetail?: Maybe<ItemBasedExpenseLineDetailModel>;
  LinkedTxn?: Maybe<Array<LinkedTxnModel>>;
};

export type LinkedTxnModel = {
  __typename?: 'LinkedTxnModel';
  TxnId: Scalars['String'];
  TxnType: Scalars['String'];
};

export type MetaDataModel = {
  __typename?: 'MetaDataModel';
  CreateTime: Scalars['DateTime'];
  LastUpdatedTime: Scalars['DateTime'];
};

export type Mutation = {
  __typename?: 'Mutation';
  htsRevokeAuthorization: Scalars['Boolean'];
  htsUpdateCredentials: Scalars['Boolean'];
  qboRevokeAuthorization: Scalars['Boolean'];
  updateMe?: Maybe<User>;
};


export type MutationHtsUpdateCredentialsArgs = {
  data: HourTimesheetCreateInput;
};


export type MutationUpdateMeArgs = {
  data: UserUpdateInput;
};

export type ParentRefModel = {
  __typename?: 'ParentRefModel';
  value: Scalars['String'];
};

export type PaymentMethodRefClassModel = {
  __typename?: 'PaymentMethodRefClassModel';
  value: Scalars['String'];
};

export type PrimaryEmailAddrModel = {
  __typename?: 'PrimaryEmailAddrModel';
  Address: Scalars['String'];
};

export type PrimaryPhoneModel = {
  __typename?: 'PrimaryPhoneModel';
  FreeFormNumber: Scalars['String'];
};

export type PurchaseEntityRefModel = {
  __typename?: 'PurchaseEntityRefModel';
  name: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type PurchaseExModel = {
  __typename?: 'PurchaseExModel';
  any: Array<AnyModel>;
};

export type PurchaseMetaDataModel = {
  __typename?: 'PurchaseMetaDataModel';
  CreateTime: Scalars['DateTime'];
  LastUpdatedTime: Scalars['DateTime'];
};

export type PurchaseModel = {
  __typename?: 'PurchaseModel';
  AccountRef: AccountRefClassModel;
  Credit?: Maybe<Scalars['Boolean']>;
  CurrencyRef: AccountRefClassModel;
  DocNumber?: Maybe<Scalars['String']>;
  EntityRef?: Maybe<PurchaseEntityRefModel>;
  Id: Scalars['String'];
  Line: Array<LineModel>;
  LinkedTxn?: Maybe<Array<LinkedTxnModel>>;
  MetaData: PurchaseMetaDataModel;
  PaymentMethodRef?: Maybe<PaymentMethodRefClassModel>;
  PaymentType: Scalars['String'];
  PrintStatus?: Maybe<Scalars['String']>;
  PrivateNote?: Maybe<Scalars['String']>;
  PurchaseEx: PurchaseExModel;
  RemitToAddr?: Maybe<RemitToAddrModel>;
  SyncToken: Scalars['String'];
  TotalAmt: Scalars['Float'];
  TxnDate: Scalars['DateTime'];
  domain: Scalars['String'];
  sparse: Scalars['Boolean'];
};

export type Query = {
  __typename?: 'Query';
  htsAuthorized: HourTimesheetAuthorized;
  htsData?: Maybe<HourTimesheetData>;
  me: User;
  qboAuthUri: Scalars['String'];
  qboAuthorized?: Maybe<Scalars['Boolean']>;
  qboCompanyInfo?: Maybe<CompanyInfoModel>;
  qboCustomers?: Maybe<Array<CustomerModel>>;
  qboPurchases: Array<PurchaseModel>;
  qboTimeActivities: Array<TimeActivityModel>;
};

export type Quickbooks = {
  __typename?: 'Quickbooks';
  accessToken: Scalars['String'];
  accessTokenExpiration: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  expiresIn: Scalars['Int'];
  id: Scalars['Int'];
  idToken: Scalars['String'];
  realmId: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiration: Scalars['DateTime'];
  tokenCreatedAt: Scalars['BigInt'];
  tokenType: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  xRefreshTokenExpiresIn: Scalars['Int'];
};

export type QuickbooksCreateOrConnectWithoutUserInput = {
  create: QuickbooksCreateWithoutUserInput;
  where: QuickbooksWhereUniqueInput;
};

export type QuickbooksCreateWithoutUserInput = {
  accessToken: Scalars['String'];
  accessTokenExpiration: Scalars['DateTime'];
  expiresIn: Scalars['Int'];
  idToken: Scalars['String'];
  realmId: Scalars['String'];
  refreshToken: Scalars['String'];
  refreshTokenExpiration: Scalars['DateTime'];
  tokenCreatedAt: Scalars['BigInt'];
  tokenType: Scalars['String'];
  xRefreshTokenExpiresIn: Scalars['Int'];
};

export type QuickbooksUpdateOneWithoutUserInput = {
  connect?: InputMaybe<QuickbooksWhereUniqueInput>;
  connectOrCreate?: InputMaybe<QuickbooksCreateOrConnectWithoutUserInput>;
  create?: InputMaybe<QuickbooksCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<QuickbooksUpdateWithoutUserInput>;
  upsert?: InputMaybe<QuickbooksUpsertWithoutUserInput>;
};

export type QuickbooksUpdateWithoutUserInput = {
  accessToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  accessTokenExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresIn?: InputMaybe<IntFieldUpdateOperationsInput>;
  idToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  realmId?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  refreshTokenExpiration?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  tokenCreatedAt?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  tokenType?: InputMaybe<StringFieldUpdateOperationsInput>;
  xRefreshTokenExpiresIn?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type QuickbooksUpsertWithoutUserInput = {
  create: QuickbooksCreateWithoutUserInput;
  update: QuickbooksUpdateWithoutUserInput;
};

export type QuickbooksWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type RefModel = {
  __typename?: 'RefModel';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type RemitToAddrModel = {
  __typename?: 'RemitToAddrModel';
  City: Scalars['String'];
  CountrySubDivisionCode: Scalars['String'];
  Id: Scalars['String'];
  Lat: Scalars['String'];
  Line1: Scalars['String'];
  Long: Scalars['String'];
  PostalCode: Scalars['String'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type TaMetaDataModel = {
  __typename?: 'TAMetaDataModel';
  CreateTime: Scalars['DateTime'];
  LastUpdatedTime: Scalars['DateTime'];
};

export type TimeActivityModel = {
  __typename?: 'TimeActivityModel';
  BillableStatus: Scalars['String'];
  CostRate: Scalars['Float'];
  CustomerRef: RefModel;
  Description?: Maybe<Scalars['String']>;
  EmployeeRef: RefModel;
  HourlyRate: Scalars['Float'];
  Hours: Scalars['Float'];
  Id: Scalars['String'];
  ItemRef: RefModel;
  MetaData: TaMetaDataModel;
  Minutes: Scalars['Float'];
  NameOf: Scalars['String'];
  Seconds: Scalars['Float'];
  SyncToken: Scalars['String'];
  Taxable: Scalars['Boolean'];
  TxnDate: Scalars['DateTime'];
  domain: Scalars['String'];
  sparse: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  HourTimesheet?: Maybe<HourTimesheet>;
  Quickbooks?: Maybe<Quickbooks>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserUpdateInput = {
  HourTimesheet?: InputMaybe<HourTimesheetUpdateOneWithoutUserInput>;
  Quickbooks?: InputMaybe<QuickbooksUpdateOneWithoutUserInput>;
};

export type Value = {
  __typename?: 'Value';
  Name: Scalars['String'];
  Value: Scalars['String'];
};

export type WebAddressModel = {
  __typename?: 'WebAddressModel';
  URI: Scalars['String'];
};

export type QboCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type QboCustomersQuery = { __typename?: 'Query', qboCustomers?: Array<{ __typename?: 'CustomerModel', Active: boolean, CompanyName?: string | null, DisplayName: string, Balance: number, BalanceWithJobs: number, BillWithParent: boolean, ClientEntityId: string, domain: string, FamilyName?: string | null, FullyQualifiedName: string, GivenName?: string | null, Id: string, IsProject: boolean, Job: boolean, PreferredDeliveryMethod: string, PrintOnCheckName: string, sparse: boolean, SyncToken: string, Taxable: boolean, V4IDPseudonym: string, BillAddr?: { __typename?: 'AddressModel', City: string, CountrySubDivisionCode: string, Id: string, Lat: string, Line1: string, Long: string, PostalCode: string } | null, PrimaryEmailAddr?: { __typename?: 'PrimaryEmailAddrModel', Address: string } | null, PrimaryPhone?: { __typename?: 'PrimaryPhoneModel', FreeFormNumber: string } | null, ParentRef?: { __typename?: 'ParentRefModel', value: string } | null }> | null };

export type QboCustomerFieldsFragment = { __typename?: 'CustomerModel', Active: boolean, CompanyName?: string | null, DisplayName: string, Balance: number, BalanceWithJobs: number, BillWithParent: boolean, ClientEntityId: string, domain: string, FamilyName?: string | null, FullyQualifiedName: string, GivenName?: string | null, Id: string, IsProject: boolean, Job: boolean, PreferredDeliveryMethod: string, PrintOnCheckName: string, sparse: boolean, SyncToken: string, Taxable: boolean, V4IDPseudonym: string, BillAddr?: { __typename?: 'AddressModel', City: string, CountrySubDivisionCode: string, Id: string, Lat: string, Line1: string, Long: string, PostalCode: string } | null, PrimaryEmailAddr?: { __typename?: 'PrimaryEmailAddrModel', Address: string } | null, PrimaryPhone?: { __typename?: 'PrimaryPhoneModel', FreeFormNumber: string } | null, ParentRef?: { __typename?: 'ParentRefModel', value: string } | null };

export type QboTimeActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type QboTimeActivitiesQuery = { __typename?: 'Query', qboTimeActivities: Array<{ __typename?: 'TimeActivityModel', Id: string, TxnDate: any, NameOf: string, BillableStatus: string, Taxable: boolean, HourlyRate: number, CostRate: number, Hours: number, Minutes: number, Seconds: number, Description?: string | null, domain: string, sparse: boolean, SyncToken: string, EmployeeRef: { __typename?: 'RefModel', value: string, name: string }, CustomerRef: { __typename?: 'RefModel', value: string, name: string }, ItemRef: { __typename?: 'RefModel', value: string, name: string }, MetaData: { __typename?: 'TAMetaDataModel', CreateTime: any, LastUpdatedTime: any } }> };

export type QboTimeActivitiesFieldsFragment = { __typename?: 'TimeActivityModel', Id: string, TxnDate: any, NameOf: string, BillableStatus: string, Taxable: boolean, HourlyRate: number, CostRate: number, Hours: number, Minutes: number, Seconds: number, Description?: string | null, domain: string, sparse: boolean, SyncToken: string, EmployeeRef: { __typename?: 'RefModel', value: string, name: string }, CustomerRef: { __typename?: 'RefModel', value: string, name: string }, ItemRef: { __typename?: 'RefModel', value: string, name: string }, MetaData: { __typename?: 'TAMetaDataModel', CreateTime: any, LastUpdatedTime: any } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, createdAt: any, updatedAt: any } };

export type MeFieldsFragment = { __typename?: 'User', id: string, createdAt: any, updatedAt: any };

export type HtsAuthorizedQueryVariables = Exact<{ [key: string]: never; }>;


export type HtsAuthorizedQuery = { __typename?: 'Query', htsAuthorized: { __typename?: 'HourTimesheetAuthorized', authorized: boolean, error?: string | null } };

export type HtsRevokeAuthorizationMutationVariables = Exact<{ [key: string]: never; }>;


export type HtsRevokeAuthorizationMutation = { __typename?: 'Mutation', htsRevokeAuthorization: boolean };

export type HtsUpdateCredentialsMutationVariables = Exact<{
  subdomain: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type HtsUpdateCredentialsMutation = { __typename?: 'Mutation', htsUpdateCredentials: boolean };

export type QboAuthorizedQueryVariables = Exact<{ [key: string]: never; }>;


export type QboAuthorizedQuery = { __typename?: 'Query', qboAuthorized?: boolean | null };

export type QboAuthUriQueryVariables = Exact<{ [key: string]: never; }>;


export type QboAuthUriQuery = { __typename?: 'Query', qboAuthUri: string };

export type QboCompanyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type QboCompanyInfoQuery = { __typename?: 'Query', qboCompanyInfo?: { __typename?: 'CompanyInfoModel', CompanyName: string, Id: string } | null };

export type QboRevokeAuthorizationMutationVariables = Exact<{ [key: string]: never; }>;


export type QboRevokeAuthorizationMutation = { __typename?: 'Mutation', qboRevokeAuthorization: boolean };

export type QboPurchasesQueryVariables = Exact<{ [key: string]: never; }>;


export type QboPurchasesQuery = { __typename?: 'Query', qboPurchases: Array<{ __typename?: 'PurchaseModel', PaymentType: string, TotalAmt: number, domain: string, sparse: boolean, Id: string, SyncToken: string, TxnDate: any, Credit?: boolean | null, PrivateNote?: string | null, PrintStatus?: string | null, DocNumber?: string | null, AccountRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, PaymentMethodRef?: { __typename?: 'PaymentMethodRefClassModel', value: string } | null, EntityRef?: { __typename?: 'PurchaseEntityRefModel', value: string, name: string, type: string } | null, PurchaseEx: { __typename?: 'PurchaseExModel', any: Array<{ __typename?: 'AnyModel', name: string, declaredType: string, scope: string, nil: boolean, globalScope: boolean, typeSubstituted: boolean, value: { __typename?: 'Value', Name: string, Value: string } }> }, MetaData: { __typename?: 'PurchaseMetaDataModel', CreateTime: any, LastUpdatedTime: any }, CurrencyRef: { __typename?: 'AccountRefClassModel', name: string, value: string }, LinkedTxn?: Array<{ __typename?: 'LinkedTxnModel', TxnId: string, TxnType: string }> | null, Line: Array<{ __typename?: 'LineModel', Id: string, Description?: string | null, Amount: number, DetailType: string, LinkedTxn?: Array<{ __typename?: 'LinkedTxnModel', TxnId: string, TxnType: string }> | null, AccountBasedExpenseLineDetail?: { __typename?: 'AccountBasedExpenseLineDetailModel', BillableStatus: string, CustomerRef?: { __typename?: 'AccountRefClassModel', value: string, name: string } | null, AccountRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, TaxCodeRef: { __typename?: 'PaymentMethodRefClassModel', value: string } } | null, ItemBasedExpenseLineDetail?: { __typename?: 'ItemBasedExpenseLineDetailModel', BillableStatus: string, UnitPrice: number, Qty: number, ItemRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, TaxCodeRef: { __typename?: 'PaymentMethodRefClassModel', value: string } } | null }>, RemitToAddr?: { __typename?: 'RemitToAddrModel', Id: string, Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string, Lat: string, Long: string } | null }> };

export type QboPurchaseFieldsFragment = { __typename?: 'PurchaseModel', PaymentType: string, TotalAmt: number, domain: string, sparse: boolean, Id: string, SyncToken: string, TxnDate: any, Credit?: boolean | null, PrivateNote?: string | null, PrintStatus?: string | null, DocNumber?: string | null, AccountRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, PaymentMethodRef?: { __typename?: 'PaymentMethodRefClassModel', value: string } | null, EntityRef?: { __typename?: 'PurchaseEntityRefModel', value: string, name: string, type: string } | null, PurchaseEx: { __typename?: 'PurchaseExModel', any: Array<{ __typename?: 'AnyModel', name: string, declaredType: string, scope: string, nil: boolean, globalScope: boolean, typeSubstituted: boolean, value: { __typename?: 'Value', Name: string, Value: string } }> }, MetaData: { __typename?: 'PurchaseMetaDataModel', CreateTime: any, LastUpdatedTime: any }, CurrencyRef: { __typename?: 'AccountRefClassModel', name: string, value: string }, LinkedTxn?: Array<{ __typename?: 'LinkedTxnModel', TxnId: string, TxnType: string }> | null, Line: Array<{ __typename?: 'LineModel', Id: string, Description?: string | null, Amount: number, DetailType: string, LinkedTxn?: Array<{ __typename?: 'LinkedTxnModel', TxnId: string, TxnType: string }> | null, AccountBasedExpenseLineDetail?: { __typename?: 'AccountBasedExpenseLineDetailModel', BillableStatus: string, CustomerRef?: { __typename?: 'AccountRefClassModel', value: string, name: string } | null, AccountRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, TaxCodeRef: { __typename?: 'PaymentMethodRefClassModel', value: string } } | null, ItemBasedExpenseLineDetail?: { __typename?: 'ItemBasedExpenseLineDetailModel', BillableStatus: string, UnitPrice: number, Qty: number, ItemRef: { __typename?: 'AccountRefClassModel', value: string, name: string }, TaxCodeRef: { __typename?: 'PaymentMethodRefClassModel', value: string } } | null }>, RemitToAddr?: { __typename?: 'RemitToAddrModel', Id: string, Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string, Lat: string, Long: string } | null };

export type HtsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HtsDataQuery = { __typename?: 'Query', htsData?: { __typename?: 'HourTimesheetData', costData: Array<{ __typename?: 'HourTimeSheetCostData', DirectCost: number, BillableCost: number, Customer: string, FirstName: string, Hours: number, Job: string, LastName: string, ServiceItem: string, TimesheetEndingDate: any }>, customers: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }>, jobs: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }>, serviceItems: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }> } | null };

export type HtsDataFieldsFragment = { __typename?: 'HourTimesheetData', costData: Array<{ __typename?: 'HourTimeSheetCostData', DirectCost: number, BillableCost: number, Customer: string, FirstName: string, Hours: number, Job: string, LastName: string, ServiceItem: string, TimesheetEndingDate: any }>, customers: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }>, jobs: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }>, serviceItems: Array<{ __typename?: 'HourTimeSheetChargeCode', active: boolean, billable: boolean, chargeCodeName: string, collectionName: string, endDate?: any | null, hierarchicalName: string, id: string, name: string, order: number, quickBooksId: string, required: boolean }> };

export const QboCustomerFieldsFragmentDoc = gql`
    fragment QboCustomerFields on CustomerModel {
  Active
  BillAddr {
    City
    CountrySubDivisionCode
    Id
    Lat
    Line1
    Long
    PostalCode
  }
  CompanyName
  DisplayName
  Balance
  BalanceWithJobs
  BillWithParent
  ClientEntityId
  domain
  FamilyName
  FullyQualifiedName
  GivenName
  Id
  IsProject
  Job
  PreferredDeliveryMethod
  PrintOnCheckName
  sparse
  SyncToken
  Taxable
  PrimaryEmailAddr {
    Address
  }
  PrimaryPhone {
    FreeFormNumber
  }
  V4IDPseudonym
  ParentRef {
    value
  }
}
    `;
export const QboTimeActivitiesFieldsFragmentDoc = gql`
    fragment QboTimeActivitiesFields on TimeActivityModel {
  Id
  TxnDate
  NameOf
  EmployeeRef {
    value
    name
  }
  CustomerRef {
    value
    name
  }
  ItemRef {
    value
    name
  }
  BillableStatus
  Taxable
  HourlyRate
  CostRate
  Hours
  Minutes
  Seconds
  Description
  domain
  sparse
  SyncToken
  MetaData {
    CreateTime
    LastUpdatedTime
  }
}
    `;
export const MeFieldsFragmentDoc = gql`
    fragment MeFields on User {
  id
  createdAt
  updatedAt
}
    `;
export const QboPurchaseFieldsFragmentDoc = gql`
    fragment QboPurchaseFields on PurchaseModel {
  AccountRef {
    value
    name
  }
  PaymentMethodRef {
    value
  }
  PaymentType
  EntityRef {
    value
    name
    type
  }
  TotalAmt
  PurchaseEx {
    any {
      name
      declaredType
      scope
      value {
        Name
        Value
      }
      nil
      globalScope
      typeSubstituted
    }
  }
  domain
  sparse
  Id
  SyncToken
  MetaData {
    CreateTime
    LastUpdatedTime
  }
  TxnDate
  CurrencyRef {
    name
    value
  }
  LinkedTxn {
    TxnId
    TxnType
  }
  Line {
    Id
    Description
    Amount
    LinkedTxn {
      TxnId
      TxnType
    }
    DetailType
    AccountBasedExpenseLineDetail {
      CustomerRef {
        value
        name
      }
      AccountRef {
        value
        name
      }
      BillableStatus
      TaxCodeRef {
        value
      }
    }
    ItemBasedExpenseLineDetail {
      BillableStatus
      ItemRef {
        value
        name
      }
      UnitPrice
      Qty
      TaxCodeRef {
        value
      }
    }
  }
  Credit
  PrivateNote
  PrintStatus
  DocNumber
  RemitToAddr {
    Id
    Line1
    City
    CountrySubDivisionCode
    PostalCode
    Lat
    Long
  }
}
    `;
export const HtsDataFieldsFragmentDoc = gql`
    fragment HtsDataFields on HourTimesheetData {
  costData {
    DirectCost
    BillableCost
    Customer
    FirstName
    Hours
    Job
    LastName
    ServiceItem
    TimesheetEndingDate
  }
  customers {
    active
    billable
    chargeCodeName
    collectionName
    endDate
    hierarchicalName
    id
    name
    order
    quickBooksId
    required
  }
  jobs {
    active
    billable
    chargeCodeName
    collectionName
    endDate
    hierarchicalName
    id
    name
    order
    quickBooksId
    required
  }
  serviceItems {
    active
    billable
    chargeCodeName
    collectionName
    endDate
    hierarchicalName
    id
    name
    order
    quickBooksId
    required
  }
}
    `;
export const QboCustomersDocument = gql`
    query QboCustomers {
  qboCustomers {
    ...QboCustomerFields
  }
}
    ${QboCustomerFieldsFragmentDoc}`;

/**
 * __useQboCustomersQuery__
 *
 * To run a query within a React component, call `useQboCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboCustomersQuery(baseOptions?: Apollo.QueryHookOptions<QboCustomersQuery, QboCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboCustomersQuery, QboCustomersQueryVariables>(QboCustomersDocument, options);
      }
export function useQboCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboCustomersQuery, QboCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboCustomersQuery, QboCustomersQueryVariables>(QboCustomersDocument, options);
        }
export type QboCustomersQueryHookResult = ReturnType<typeof useQboCustomersQuery>;
export type QboCustomersLazyQueryHookResult = ReturnType<typeof useQboCustomersLazyQuery>;
export type QboCustomersQueryResult = Apollo.QueryResult<QboCustomersQuery, QboCustomersQueryVariables>;
export const QboTimeActivitiesDocument = gql`
    query QboTimeActivities {
  qboTimeActivities {
    ...QboTimeActivitiesFields
  }
}
    ${QboTimeActivitiesFieldsFragmentDoc}`;

/**
 * __useQboTimeActivitiesQuery__
 *
 * To run a query within a React component, call `useQboTimeActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboTimeActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboTimeActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboTimeActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<QboTimeActivitiesQuery, QboTimeActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboTimeActivitiesQuery, QboTimeActivitiesQueryVariables>(QboTimeActivitiesDocument, options);
      }
export function useQboTimeActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboTimeActivitiesQuery, QboTimeActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboTimeActivitiesQuery, QboTimeActivitiesQueryVariables>(QboTimeActivitiesDocument, options);
        }
export type QboTimeActivitiesQueryHookResult = ReturnType<typeof useQboTimeActivitiesQuery>;
export type QboTimeActivitiesLazyQueryHookResult = ReturnType<typeof useQboTimeActivitiesLazyQuery>;
export type QboTimeActivitiesQueryResult = Apollo.QueryResult<QboTimeActivitiesQuery, QboTimeActivitiesQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...MeFields
  }
}
    ${MeFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const HtsAuthorizedDocument = gql`
    query HtsAuthorized {
  htsAuthorized {
    authorized
    error
  }
}
    `;

/**
 * __useHtsAuthorizedQuery__
 *
 * To run a query within a React component, call `useHtsAuthorizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtsAuthorizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtsAuthorizedQuery({
 *   variables: {
 *   },
 * });
 */
export function useHtsAuthorizedQuery(baseOptions?: Apollo.QueryHookOptions<HtsAuthorizedQuery, HtsAuthorizedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HtsAuthorizedQuery, HtsAuthorizedQueryVariables>(HtsAuthorizedDocument, options);
      }
export function useHtsAuthorizedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HtsAuthorizedQuery, HtsAuthorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HtsAuthorizedQuery, HtsAuthorizedQueryVariables>(HtsAuthorizedDocument, options);
        }
export type HtsAuthorizedQueryHookResult = ReturnType<typeof useHtsAuthorizedQuery>;
export type HtsAuthorizedLazyQueryHookResult = ReturnType<typeof useHtsAuthorizedLazyQuery>;
export type HtsAuthorizedQueryResult = Apollo.QueryResult<HtsAuthorizedQuery, HtsAuthorizedQueryVariables>;
export const HtsRevokeAuthorizationDocument = gql`
    mutation HtsRevokeAuthorization {
  htsRevokeAuthorization
}
    `;
export type HtsRevokeAuthorizationMutationFn = Apollo.MutationFunction<HtsRevokeAuthorizationMutation, HtsRevokeAuthorizationMutationVariables>;

/**
 * __useHtsRevokeAuthorizationMutation__
 *
 * To run a mutation, you first call `useHtsRevokeAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHtsRevokeAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [htsRevokeAuthorizationMutation, { data, loading, error }] = useHtsRevokeAuthorizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useHtsRevokeAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<HtsRevokeAuthorizationMutation, HtsRevokeAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HtsRevokeAuthorizationMutation, HtsRevokeAuthorizationMutationVariables>(HtsRevokeAuthorizationDocument, options);
      }
export type HtsRevokeAuthorizationMutationHookResult = ReturnType<typeof useHtsRevokeAuthorizationMutation>;
export type HtsRevokeAuthorizationMutationResult = Apollo.MutationResult<HtsRevokeAuthorizationMutation>;
export type HtsRevokeAuthorizationMutationOptions = Apollo.BaseMutationOptions<HtsRevokeAuthorizationMutation, HtsRevokeAuthorizationMutationVariables>;
export const HtsUpdateCredentialsDocument = gql`
    mutation HtsUpdateCredentials($subdomain: String!, $username: String!, $password: String!) {
  htsUpdateCredentials(
    data: {subdomain: $subdomain, username: $username, password: $password}
  )
}
    `;
export type HtsUpdateCredentialsMutationFn = Apollo.MutationFunction<HtsUpdateCredentialsMutation, HtsUpdateCredentialsMutationVariables>;

/**
 * __useHtsUpdateCredentialsMutation__
 *
 * To run a mutation, you first call `useHtsUpdateCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHtsUpdateCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [htsUpdateCredentialsMutation, { data, loading, error }] = useHtsUpdateCredentialsMutation({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useHtsUpdateCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<HtsUpdateCredentialsMutation, HtsUpdateCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HtsUpdateCredentialsMutation, HtsUpdateCredentialsMutationVariables>(HtsUpdateCredentialsDocument, options);
      }
export type HtsUpdateCredentialsMutationHookResult = ReturnType<typeof useHtsUpdateCredentialsMutation>;
export type HtsUpdateCredentialsMutationResult = Apollo.MutationResult<HtsUpdateCredentialsMutation>;
export type HtsUpdateCredentialsMutationOptions = Apollo.BaseMutationOptions<HtsUpdateCredentialsMutation, HtsUpdateCredentialsMutationVariables>;
export const QboAuthorizedDocument = gql`
    query QboAuthorized {
  qboAuthorized
}
    `;

/**
 * __useQboAuthorizedQuery__
 *
 * To run a query within a React component, call `useQboAuthorizedQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboAuthorizedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboAuthorizedQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboAuthorizedQuery(baseOptions?: Apollo.QueryHookOptions<QboAuthorizedQuery, QboAuthorizedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboAuthorizedQuery, QboAuthorizedQueryVariables>(QboAuthorizedDocument, options);
      }
export function useQboAuthorizedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboAuthorizedQuery, QboAuthorizedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboAuthorizedQuery, QboAuthorizedQueryVariables>(QboAuthorizedDocument, options);
        }
export type QboAuthorizedQueryHookResult = ReturnType<typeof useQboAuthorizedQuery>;
export type QboAuthorizedLazyQueryHookResult = ReturnType<typeof useQboAuthorizedLazyQuery>;
export type QboAuthorizedQueryResult = Apollo.QueryResult<QboAuthorizedQuery, QboAuthorizedQueryVariables>;
export const QboAuthUriDocument = gql`
    query QboAuthUri {
  qboAuthUri
}
    `;

/**
 * __useQboAuthUriQuery__
 *
 * To run a query within a React component, call `useQboAuthUriQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboAuthUriQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboAuthUriQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboAuthUriQuery(baseOptions?: Apollo.QueryHookOptions<QboAuthUriQuery, QboAuthUriQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboAuthUriQuery, QboAuthUriQueryVariables>(QboAuthUriDocument, options);
      }
export function useQboAuthUriLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboAuthUriQuery, QboAuthUriQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboAuthUriQuery, QboAuthUriQueryVariables>(QboAuthUriDocument, options);
        }
export type QboAuthUriQueryHookResult = ReturnType<typeof useQboAuthUriQuery>;
export type QboAuthUriLazyQueryHookResult = ReturnType<typeof useQboAuthUriLazyQuery>;
export type QboAuthUriQueryResult = Apollo.QueryResult<QboAuthUriQuery, QboAuthUriQueryVariables>;
export const QboCompanyInfoDocument = gql`
    query QboCompanyInfo {
  qboCompanyInfo {
    CompanyName
    Id
  }
}
    `;

/**
 * __useQboCompanyInfoQuery__
 *
 * To run a query within a React component, call `useQboCompanyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboCompanyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboCompanyInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboCompanyInfoQuery(baseOptions?: Apollo.QueryHookOptions<QboCompanyInfoQuery, QboCompanyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboCompanyInfoQuery, QboCompanyInfoQueryVariables>(QboCompanyInfoDocument, options);
      }
export function useQboCompanyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboCompanyInfoQuery, QboCompanyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboCompanyInfoQuery, QboCompanyInfoQueryVariables>(QboCompanyInfoDocument, options);
        }
export type QboCompanyInfoQueryHookResult = ReturnType<typeof useQboCompanyInfoQuery>;
export type QboCompanyInfoLazyQueryHookResult = ReturnType<typeof useQboCompanyInfoLazyQuery>;
export type QboCompanyInfoQueryResult = Apollo.QueryResult<QboCompanyInfoQuery, QboCompanyInfoQueryVariables>;
export const QboRevokeAuthorizationDocument = gql`
    mutation QboRevokeAuthorization {
  qboRevokeAuthorization
}
    `;
export type QboRevokeAuthorizationMutationFn = Apollo.MutationFunction<QboRevokeAuthorizationMutation, QboRevokeAuthorizationMutationVariables>;

/**
 * __useQboRevokeAuthorizationMutation__
 *
 * To run a mutation, you first call `useQboRevokeAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQboRevokeAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qboRevokeAuthorizationMutation, { data, loading, error }] = useQboRevokeAuthorizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useQboRevokeAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<QboRevokeAuthorizationMutation, QboRevokeAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QboRevokeAuthorizationMutation, QboRevokeAuthorizationMutationVariables>(QboRevokeAuthorizationDocument, options);
      }
export type QboRevokeAuthorizationMutationHookResult = ReturnType<typeof useQboRevokeAuthorizationMutation>;
export type QboRevokeAuthorizationMutationResult = Apollo.MutationResult<QboRevokeAuthorizationMutation>;
export type QboRevokeAuthorizationMutationOptions = Apollo.BaseMutationOptions<QboRevokeAuthorizationMutation, QboRevokeAuthorizationMutationVariables>;
export const QboPurchasesDocument = gql`
    query QboPurchases {
  qboPurchases {
    ...QboPurchaseFields
  }
}
    ${QboPurchaseFieldsFragmentDoc}`;

/**
 * __useQboPurchasesQuery__
 *
 * To run a query within a React component, call `useQboPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQboPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQboPurchasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQboPurchasesQuery(baseOptions?: Apollo.QueryHookOptions<QboPurchasesQuery, QboPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QboPurchasesQuery, QboPurchasesQueryVariables>(QboPurchasesDocument, options);
      }
export function useQboPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QboPurchasesQuery, QboPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QboPurchasesQuery, QboPurchasesQueryVariables>(QboPurchasesDocument, options);
        }
export type QboPurchasesQueryHookResult = ReturnType<typeof useQboPurchasesQuery>;
export type QboPurchasesLazyQueryHookResult = ReturnType<typeof useQboPurchasesLazyQuery>;
export type QboPurchasesQueryResult = Apollo.QueryResult<QboPurchasesQuery, QboPurchasesQueryVariables>;
export const HtsDataDocument = gql`
    query HtsData {
  htsData {
    ...HtsDataFields
  }
}
    ${HtsDataFieldsFragmentDoc}`;

/**
 * __useHtsDataQuery__
 *
 * To run a query within a React component, call `useHtsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHtsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHtsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHtsDataQuery(baseOptions?: Apollo.QueryHookOptions<HtsDataQuery, HtsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HtsDataQuery, HtsDataQueryVariables>(HtsDataDocument, options);
      }
export function useHtsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HtsDataQuery, HtsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HtsDataQuery, HtsDataQueryVariables>(HtsDataDocument, options);
        }
export type HtsDataQueryHookResult = ReturnType<typeof useHtsDataQuery>;
export type HtsDataLazyQueryHookResult = ReturnType<typeof useHtsDataLazyQuery>;
export type HtsDataQueryResult = Apollo.QueryResult<HtsDataQuery, HtsDataQueryVariables>;